export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-scale/src/constant.js
// module id = AYLb
// module chunks = 0